import React from 'react'
import { Link } from 'gatsby'
import { Location } from '@reach/router'
import styled, { Box } from '@xstyled/styled-components'
import {
  Navbar,
  NavbarBrand,
  NavbarBrandLink,
  NavbarSecondary,
  NavbarLink,
} from '../components/Navbar'
import {
  useLangKey,
  I18nLink,
  toEnglish,
  toSpanish,
} from '../components/I18nContext'

const SocialLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44;
  width: 44;
  color: lighter;
  transition: base;

  &:hover,
  &:focus {
    outline: none;
    color: accent;
  }
`

const locales = {
  es: {
    about: 'Sobre mi',
    blog: 'Blog',
    projects: 'Proyectos',
  },
  en: {
    about: 'About',
    blog: 'Blog',
    projects: 'Projects',
  },
}

export function AppNavbar() {
  const langKey = useLangKey()
  const t = locales[langKey]
  return (
    <Navbar>
      <NavbarBrandLink as={I18nLink} to="/">
        <NavbarBrand>
          <span role="img" aria-label="lion emoji">
            🦁
          </span>{' '}
          León G.
        </NavbarBrand>
      </NavbarBrandLink>
      <NavbarSecondary>
        <Location>
          {({ location }) => (
            <>
              {langKey === 'en' && (
                <SocialLink title="Spanish" as={Link} to={toSpanish(location)}>
                  <Box as="span" fontSize={20} role="img" aria-label="Español">
                    <span role="img" aria-label="Spain Flag">
                      🇪🇸
                    </span>
                  </Box>
                </SocialLink>
              )}
              {langKey === 'es' && (
                <SocialLink title="English" as={Link} to={toEnglish(location)}>
                  <Box as="span" fontSize={20} role="img" aria-label="English">
                    <span role="img" aria-label="Great Britain Flag">
                      🇬🇧
                    </span>
                  </Box>
                </SocialLink>
              )}
            </>
          )}
        </Location>
        <NavbarLink as={I18nLink} to="/about">
          {t.about}
        </NavbarLink>
        <NavbarLink as={I18nLink} to="/blog">
          {t.blog}
        </NavbarLink>
        <NavbarLink as={I18nLink} to="/projects">
          {t.projects}
        </NavbarLink>
      </NavbarSecondary>
    </Navbar>
  )
}
